import React from 'react';
import styled from 'styled-components';

export const BigContainer = styled.div`
    margin: 2em;
`;

export const StyledDiv = styled.div`
    display: flex;
    margin: 2em auto;
`;